module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidade solicitante")]), _vm._v(" "), _c('select-unidade', {
    on: {
      "setUnidadeSelecionada": function (unidadeSelecionada) {
        _vm.setUnidadeSolicitante(unidadeSelecionada);
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Procedimento")]), _vm._v(" "), _c('select-procedimento', {
    on: {
      "setProcedimentoSelecionado": function (procedimentoSelecionado) {
        _vm.setProcedimentoSelecionado(procedimentoSelecionado);
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Competência")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.distribuicao_id),
      expression: "filtros.distribuicao_id"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "distribuicao_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.distribuicoes), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(_vm._f("competencia")(item.data_competencia)))])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacoes),
      expression: "filtros.situacoes"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.MARCADA,
      "checked": Array.isArray(_vm.filtros.situacoes) ? _vm._i(_vm.filtros.situacoes, _vm.SITUACAO_SOLICITACAO.MARCADA) > -1 : (_vm.filtros.situacoes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.situacoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.SITUACAO_SOLICITACAO.MARCADA,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros, "situacoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros, "situacoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros, "situacoes", $$c)
        }
      }
    }
  }), _vm._v("Marcada\n              ")]), _vm._v(" "), (this.$store.state.user.nivel == 'administrador') ? _c('div', [_c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacoes),
      expression: "filtros.situacoes"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.EM_REGULACAO,
      "checked": Array.isArray(_vm.filtros.situacoes) ? _vm._i(_vm.filtros.situacoes, _vm.SITUACAO_SOLICITACAO.EM_REGULACAO) > -1 : (_vm.filtros.situacoes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.situacoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.SITUACAO_SOLICITACAO.EM_REGULACAO,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros, "situacoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros, "situacoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros, "situacoes", $$c)
        }
      }
    }
  }), _vm._v("Em regulação\n              ")]), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacoes),
      expression: "filtros.situacoes"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.REGULADA,
      "checked": Array.isArray(_vm.filtros.situacoes) ? _vm._i(_vm.filtros.situacoes, _vm.SITUACAO_SOLICITACAO.REGULADA) > -1 : (_vm.filtros.situacoes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.situacoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.SITUACAO_SOLICITACAO.REGULADA,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros, "situacoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros, "situacoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros, "situacoes", $$c)
        }
      }
    }
  }), _vm._v("Regulada\n                ")]), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacoes),
      expression: "filtros.situacoes"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.NEGATIVADA,
      "checked": Array.isArray(_vm.filtros.situacoes) ? _vm._i(_vm.filtros.situacoes, _vm.SITUACAO_SOLICITACAO.NEGATIVADA) > -1 : (_vm.filtros.situacoes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.situacoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.SITUACAO_SOLICITACAO.NEGATIVADA,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros, "situacoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros, "situacoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros, "situacoes", $$c)
        }
      }
    }
  }), _vm._v("Negativada\n                ")]), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacoes),
      expression: "filtros.situacoes"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.INFORMACAO_PENDENTE,
      "checked": Array.isArray(_vm.filtros.situacoes) ? _vm._i(_vm.filtros.situacoes, _vm.SITUACAO_SOLICITACAO.INFORMACAO_PENDENTE) > -1 : (_vm.filtros.situacoes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.situacoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.SITUACAO_SOLICITACAO.INFORMACAO_PENDENTE,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros, "situacoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros, "situacoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros, "situacoes", $$c)
        }
      }
    }
  }), _vm._v("Informação pendente\n                ")]), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacoes),
      expression: "filtros.situacoes"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.INFORMACAO_ADICIONAL,
      "checked": Array.isArray(_vm.filtros.situacoes) ? _vm._i(_vm.filtros.situacoes, _vm.SITUACAO_SOLICITACAO.INFORMACAO_ADICIONAL) > -1 : (_vm.filtros.situacoes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.situacoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.SITUACAO_SOLICITACAO.INFORMACAO_ADICIONAL,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros, "situacoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros, "situacoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros, "situacoes", $$c)
        }
      }
    }
  }), _vm._v("Informação adicional\n                ")])]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacoes),
      expression: "filtros.situacoes"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.CONFIRMADA,
      "checked": Array.isArray(_vm.filtros.situacoes) ? _vm._i(_vm.filtros.situacoes, _vm.SITUACAO_SOLICITACAO.CONFIRMADA) > -1 : (_vm.filtros.situacoes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.situacoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.SITUACAO_SOLICITACAO.CONFIRMADA,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros, "situacoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros, "situacoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros, "situacoes", $$c)
        }
      }
    }
  }), _vm._v("Confirmada\n              ")]), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacoes),
      expression: "filtros.situacoes"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.CANCELADA,
      "checked": Array.isArray(_vm.filtros.situacoes) ? _vm._i(_vm.filtros.situacoes, _vm.SITUACAO_SOLICITACAO.CANCELADA) > -1 : (_vm.filtros.situacoes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.situacoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.SITUACAO_SOLICITACAO.CANCELADA,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros, "situacoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros, "situacoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros, "situacoes", $$c)
        }
      }
    }
  }), _vm._v("Cancelada\n              ")]), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacoes),
      expression: "filtros.situacoes"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.FALTA,
      "checked": Array.isArray(_vm.filtros.situacoes) ? _vm._i(_vm.filtros.situacoes, _vm.SITUACAO_SOLICITACAO.FALTA) > -1 : (_vm.filtros.situacoes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.situacoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.SITUACAO_SOLICITACAO.FALTA,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros, "situacoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros, "situacoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros, "situacoes", $$c)
        }
      }
    }
  }), _vm._v("Falta\n              ")]), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacoes),
      expression: "filtros.situacoes"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.REALIZADA,
      "checked": Array.isArray(_vm.filtros.situacoes) ? _vm._i(_vm.filtros.situacoes, _vm.SITUACAO_SOLICITACAO.REALIZADA) > -1 : (_vm.filtros.situacoes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.situacoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.SITUACAO_SOLICITACAO.REALIZADA,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros, "situacoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros, "situacoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros, "situacoes", $$c)
        }
      }
    }
  }), _vm._v("Realizada\n              ")])])]), _vm._v(" "), _c('div', {
    ref: "filtrar",
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "disabled": !_vm.finalizado,
      "data-toggle": "tooltip",
      "title": "Pesquisar Relatório de Solicitação",
      "id": "resultado"
    },
    on: {
      "click": function($event) {
        _vm.getDataTable()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Pesquisar\n              ")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-bordered"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.unidade))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.procedimento))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.quantidade))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("competencia")(item.competencia)))])])
  }))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Solicitações")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Unidade solicitante")]), _vm._v(" "), _c('th', [_vm._v("Procedimento")]), _vm._v(" "), _c('th', [_vm._v("Quantidade solicitada")]), _vm._v(" "), _c('th', [_vm._v("Mês/Ano")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-06dee3ba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/administracao/relatorios/solicitacoes_sintetico/index.vue
// module id = 788
// module chunks = 0